<template>
    <div class="search-third-form">
        <h2 class="mt-0 mr-4 flex-row mb-0" :class="{ 'mb-4': !getLoading }">
            <span v-if="getLoading" class="loader mt-2" />
            <span class="self-center" :class="{ 'loading-title ml-2': getLoading }">{{
                searchTitle
            }}</span>
        </h2>
        <el-form
            v-if="!getLoading"
            :model="searchModel"
            ref="searchThirdForm"
            class="flex-column mb-0"
        >
            <div class="flex-row">
                <el-form-item prop="name" class="wp-8 mb-0">
                    <el-input
                        ref="search-input"
                        v-model="name"
                        @keyup.enter.native="process()"
                        :data-bot="getDatabot('name-popup-name', current)"
                        prefix-icon="icon-search"
                    />
                </el-form-item>
                <el-form-item prop="country" class="wp-3 mx-2 mb-0">
                    <el-select
                        v-model="country"
                        :data-bot="getDatabot('name-popup-country', current)"
                    >
                        <el-option value="FR" :label="$t.__('common.countries.france')"></el-option>
                        <el-option value="GB" :label="$t.__('common.countries.uk')"></el-option>
                    </el-select>
                </el-form-item>

                <CompassButton
                    :label="$t.__('common.actions.search')"
                    type="primary"
                    @click="process()"
                    class="py-0"
                    :disabled="disabledBtn"
                    :data-bot="getDatabot('name-popup-btn', current)"
                />
            </div>
            <p class="fs-2 gray-80 mt-1 pb-3 bb-1">
                {{ $l10n.__('Nom de la société, SIREN et SIRET') }}
            </p>
            <div>
                <!-- IF SEARCHED NAME ALREADY EXISTS -->
                <div
                    v-if="!loading && nameExistsList.length > 0 && !disableExistingCompanyList"
                    class="flex-column mt-3 prelative bb-1 pb-2"
                >
                    <div class="flex-column search-third-form-exist-container prelative">
                        <p class="fs-2 gray-80 mt-1">
                            {{
                                $l10n.__(
                                    'Société(s) déjà existante(s) dans le répertoire de société',
                                )
                            }}
                        </p>
                        <ul class="m-0 wp-10">
                            <form-fields-companies-list
                                v-for="(company, index) in nameExistsList"
                                :key="index"
                                :company="company"
                                :overview="true"
                                :popupForm="true"
                                allowBadge
                                :overviewWording="$t.__('forms.popups.SearchThirdForm.overview')"
                            />
                        </ul>
                    </div>
                </div>

                <!-- LIST OF RESULT -->
                <div v-if="!loading && resultSearch.length > 0" class="flex-column pb-2 mt-2">
                    <div class="flex-column search-third-form-container prelative">
                        <p
                            class="fs-2 gray-80 mt-1 wp-10"
                            :class="{ 'mt-3': nameExistsList.length <= 0 }"
                        >
                            {{ $l10n.__('Résultats de votre recherche') }}
                        </p>
                        <ul class="m-0 wp-10">
                            <form-fields-companies-list
                                v-for="(company, index) in resultSearch"
                                :key="index"
                                :company="company"
                                :enabled="true"
                                :popupForm="true"
                                displaySiret
                                @select-company="selectCompany"
                            />
                        </ul>
                    </div>
                </div>
                <!--  NO RESULT FOUND -->
                <div
                    v-if="!loading && resultSearch.length <= 0"
                    class="ai-center flex-column search-third-form-not-found"
                >
                    <img src="/ressources/public/img/error/no-result.svg" class="h-auto my-4" />
                    <p class="semibold gray-60 acenter pb-4 lh-20">
                        {{
                            $l10n.__(
                                'Aucun résultat ne semble correspondre à votre recherche, modifiez vos critères.',
                            )
                        }}
                    </p>
                </div>

                <!-- LOADER -->
                <div
                    v-show="loading"
                    class="ai-center flex-column prelative search-third-form-not-loading"
                >
                    <preloader :display="loading" />
                </div>
            </div>
            <a
                v-if="!disableCreate"
                href="javascript:;"
                @click="$emit('close')"
                class="fs-3 pt-4 lh-20 semibold bt-1 hover-primary-100"
                >{{ $l10n.__('Ajouter une société manuellement') }}</a
            >
        </el-form>
    </div>
</template>

<script>
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';
import FormFieldsCompaniesList from 'vcomponents/thirds/thirdscomponents/FormFieldsCompaniesList.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    name: 'searchThirdForm',
    components: {
        Preloader,
        FormFieldsCompaniesList,
    },
    mixins: [DataBotsFormsMixins],
    props: {
        current: {
            type: String,
            required: true,
        },
        defaultValue: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            loading: true,
            searchModel: {
                name: null,
                country: null,
            },
            resultSearch: [],
            country: 'FR',
            name: null,
            nameExistsList: [],
        };
    },
    mounted() {
        this.$nextTick(() => this.$refs['search-input'].focus());
    },
    created() {
        if (this.getLoading) {
            this.$store.commit(`${this.current}/setLoading`, false);
        }
        this.name = this.defaultValue;
        this.process();
        if (!this.name) {
            this.loading = false;
        }
    },
    computed: {
        getLoading() {
            return this.$store.getters[`${this.current}/getLoading`];
        },
        searchTitle() {
            return this.loading
                ? window.i18n.__("Recherches d'informations en cours")
                : window.i18n.__('Rechercher automatiquement les informations de la société');
        },
        disabledBtn() {
            if (_.isNil(this.name)) {
                return true;
            } else if (this.name && this.name.trim().length <= 0) {
                return true;
            } else if (this.loading) {
                return true;
            }
            return false;
        },
        disableCreate() {
            return this.options.disableCreate;
        },
        disableExistingCompanyList() {
            return this.options.disableSlsyList;
        },
    },
    methods: {
        /**
         * Search companies based on siret, siren or name
         * active loader during that search
         */
        process() {
            if (this.name && this.name.length > 0) {
                this.loading = true;
                this.$store
                    .dispatch(`${this.current}/fetchCompaniesSearchScan`, {
                        q: this.name,
                        countryCode: this.country,
                        district: null,
                    })
                    .then((res) => {
                        this.resultSearch = res.data;
                        this.$store
                            .dispatch(`${this.current}/fetchCompaniesList`, {
                                search: this.name,
                                siretAllowed: true,
                            })
                            .then((res) => {
                                this.loading = false;
                                this.nameExistsList = res;
                                for (let i = 0; i < this.nameExistsList.length; i++) {
                                    this.nameExistsList[i].type =
                                        this.nameExistsList[i].object.sub_type;
                                }
                            })
                            .catch((err) => {
                                this.loading = false;
                            });
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            }
        },

        /**
         * fill/overwrite the fields of form with selected company. then quit the popup.
         * @params {} company
         */
        selectCompany(company) {
            if (!_.isNil(company)) {
                this.$store.commit(`${this.current}/setLoading`, true);
                let datas = {
                    id: company.id,
                    params: {
                        countryCode: this.country,
                        siret: company.siret,
                    },
                };
                this.$store
                    .dispatch(`${this.current}/fetchCompanyBySearchScan`, datas)
                    .then((res) => {
                        //successfully recover datas
                        res.address.countryCode = this.country;
                        this.$emit('next', res);
                    })
                    .catch((err) => {
                        this.loading = false;
                        Push.error(
                            this.$l10n.__("Une erreur est survenue lors de l'ajout d'informations"),
                        );
                        this.$store.commit(`${this.current}/setLoading`, false);
                    });
            }
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.search-third-form {
    .loading-title {
        font-weight: 500;
    }
    .loader {
        position: relative !important;
        border: 2px solid $gray-60;
        border-bottom: 2px solid $gray-0;
        border-radius: 50%;
        background-color: $white;
        width: 16px;
        height: 16px;
        top: -6px !important;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }
    /* Safari */
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .el-input--prefix {
        .el-input__inner {
            padding-left: 40px;
        }
        .el-input__prefix {
            left: 14px;
            i {
                color: $gray-100;
                font-size: 16px;
            }
        }
    }
    .search-third-form-exist-container {
        max-height: 130px;
        & > ul {
            overflow-y: scroll;
        }
    }
    .form-fields-companies-list {
        padding: 8px !important;
    }
    .search-third-form-container {
        li {
            &:hover,
            &:focus {
                background: $primary-05;
                border-radius: 4px;
            }
        }
    }
}
</style>
